import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import { Menu, Close, ChevronRight } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import BrandLogo from "../common/BrandLogo";
import theme from '../../../src/theme/theme';



const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { name: "About Us", id: "about" },
    { name: "Services", id: "services" },
    { name: "Testimonials", id: "testimonials" },
    { name: "Contact", id: "contact" },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileOpen(false);
    }
  };

  const drawer = (
    <Box
      sx={{
        width: 280,
        py: 3,
        background: "#ffffff",
        height: "100%",
        color: theme.palette.primary.main,
        overflowY: "auto",
      }}
    >
      <List>
        {navItems.map((item) => (
          <ListItem
            button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            sx={{ py: 1.5 }}
          >
            <ChevronRight sx={{ mr: 1, color: theme.palette.secondary.main }} />
            <ListItemText
              primary={item.name}
              primaryTypographyProps={{
                fontWeight: 500,
                color: theme.palette.primary.main,
              }}
            />
          </ListItem>
        ))}
        <Box sx={{ px: 2, mt: 2 }}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            onClick={() => scrollToSection("contact")}
            sx={{ width: "170px", mx: "auto", }} // 🎯
          >
            Join For Services
          </Button>
        </Box>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: scrolled ? "rgba(255, 255, 255, 0.95)" : "transparent",
          boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.05)" : "none",
          backdropFilter: "blur(10px)",
          transition: "all 0.3s ease",
          color: theme.palette.primary.main,
          zIndex: 1201,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <BrandLogo />
            </Box>

            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              {navItems.map((item) => (
                <Button
                  key={item.id}
                  color="inherit"
                  onClick={() => scrollToSection(item.id)}
                  sx={{
                    mx: 1,
                    color: theme.palette.primary.main,
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </Button>
              ))}
              <Button
                variant="contained"
                color="secondary"
                onClick={() => scrollToSection("contact")}
                sx={{ ml: 2 }}
              >
                Join For Services
              </Button>
            </Box>

            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{
                display: { md: "none" },
                color: theme.palette.primary.main,
              }}
            >
              <Menu />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { md: "none" } }}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            width: isMobile ? "100%" : 280,
            maxWidth: "100vw",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            px: 2,
            py: 2,
            background: "rgba(255,255,255,0.9)",
            borderBottom: "1px solid #eee",
          }}
        >
          <IconButton onClick={handleDrawerToggle} aria-label="close">
            <Close sx={{ color: theme.palette.primary.main }} />
          </IconButton>
        </Box>
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar; 